export const REVIEW_SUGGESTIONS_EVENT_NAMES = Object.freeze({
  ACCEPT_ML_SUGGESTION: 'accept_ml_suggestion',
  REJECT_ML_SUGGESTION: 'reject_ml_suggestion',
  EVALUATE_TRACKING_DETAILS: 'evaluate_tracking_details'
});